let playYT = () => {

    let item = document.querySelectorAll('.m-f-item-box')

    let itemA = [...item][0].querySelector('a')

    $(window).resize(() => {
        window.pf2eWidth = itemA.offsetWidth - 12
        window.pf2eHeight = window.pf2eWidth * 0.5625
    }).trigger('resize')

    $('.md-f-p-video').map((index, el) => {

        let id = $(el).data('video-id')

        $(window).on('onYouTubeIframeAPIReady', () => {
            $(el).parents('.m-f-item-box').get(0).player = new YT.Player(`md-f-p-yt${index + 1}`, {
                width: window.pf2eWidth,
                height: window.pf2eHeight,
                videoId: id,
                playerVars: {
                    'autoplay': 1,
                    'controls': 0,
                    'rel': 0,
                    'fs': 0,
                    'showinfo': 0,
                    'modestbranding': 1,
                },
                events: {
                    'onStateChange': (e) => {
                        if (e.data === 1 && !window.__is_ytb_ready) {
                            e.target.pauseVideo()
                        }
                        if (e.data === 0) {
                            e.target.playVideo()
                        }
                    }
                }
            })
        })
    })

    ;[...item].map((value) => {
        $(window).resize(() => {
            if (window.innerWidth > gp_max_md) {
                $(value).hover(() => {
                    window.__is_ytb_ready = true
                    window.pf2eWidth = itemA.offsetWidth - 12
                    window.pf2eHeight = window.pf2eWidth * 0.5625
                    value.player.setSize(window.pf2eWidth, window.pf2eHeight)
                    $(value).find('.md-f-p-video').removeClass('disNone').css('display', 'block')
                    $(value).find('img').hide()
                    value.player.playVideo()
                }, () => {
                    $(value).find('.md-f-p-video').removeClass('disNone').css('display', 'block')
                    $(value).find('img').hide()
                    value.player.pauseVideo()
                })
            } else {
                $(value).find('.md-f-p-video').addClass('disNone')
                $(value).find('img').css('display', 'block')
            }
        }).trigger('resize')
    })

    $(window).resize(() => {
        ;[...item].map((value) => {
            value.player.setSize(window.pf2eWidth, window.pf2eHeight)
        })
    })

}

export default playYT